import { render, staticRenderFns } from "./FormDepartmentOwnershipModal.vue?vue&type=template&id=2b18318e&scoped=true&"
import script from "./FormDepartmentOwnershipModal.vue?vue&type=script&lang=js&"
export * from "./FormDepartmentOwnershipModal.vue?vue&type=script&lang=js&"
import style0 from "./FormDepartmentOwnershipModal.vue?vue&type=style&index=0&id=2b18318e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18318e",
  null
  
)

export default component.exports